'use client'
import React, { useState, useEffect, useRef } from 'react'
// import { useSession } from 'next-auth/react'
import Image from 'next/image'
import Link from 'next/link'
import { AiOutlineLayout, AiFillHeart, AiOutlineHeart } from "react-icons/ai"
import { BiSolidBed, BiSolidBath } from "react-icons/bi"
import { MdPets } from "react-icons/md"
import { IoMdVideocam } from 'react-icons/io'
import { sendLike } from '@services/sendLike'
import CurrencySymbol from '@components/CurrencySymbol'
import LinkComponent from './LinkComponent';

import tailwindConfig from '@tailwind.config'
import { sendGAEvent } from '@next/third-parties/google'

const LargePropertyCard = ({ property, imageWidth = 300, imageHeight = 200, includeInactive = false, newLimit, isLast, district = undefined, dictionary, lang }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
        height: 90,
        overflow: 'hidden',
        z: 10
    };

    // const [showLikeBtn, setShowLikeBtn] = useState(false)
    const [isLiked, setIsLiked] = useState(property.isLiked)
    // const { data: session } = useSession()

    const cardRef = useRef();

    const handleLike = async () => {
        const isLike = await sendLike(property.id)
        setIsLiked((prevLike) => !prevLike)
        property.isLiked = !property.isLiked
    };

    useEffect(() => {
        if (!cardRef?.current) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (isLast && entry.isIntersecting) {
                newLimit();
                observer.unobserve(entry.target);
            }
        });

        observer.observe(cardRef.current);
    }, [isLast]);

    // useEffect(() => {
    //     if (session !== null) {
    //         setShowLikeBtn(true)
    //     }
    // }, [])

    // const isSmallDevice = window.innerWidth < 768;
    // const isTablet = window.innerWidth < 1024;

    return (
        <div 
            ref={cardRef} 
            className={`relative sm:w-[${imageWidth}px] w-full`}
            onClick={() => sendGAEvent({ 
                event: "select_property",
                property_id: property.ref || property.id,
                property_name: property.name,
                property_type: property.metaCategory,
                property_location: property.districts[0]?.subdistrictName?.['en'],
                property_saletype: property.metaSaleType
            })} 
        >
            {(isLiked == false) && (
                <div title="Left-click on this icon to save this property" onClick={handleLike} className='card-unliked'>
                    <AiOutlineHeart
                        size={24}
                        color={tailwindConfig.theme.extend.colors.icon}
                    />
                </div>
            )}
            {(isLiked == true) && (
                <div title="Left-click to unlike this property" onClick={handleLike} className='card-liked'>
                    <AiFillHeart
                        size={24}
                        color={tailwindConfig.theme.extend.colors.price}
                    />
                </div>
            )}
            <LinkComponent
                href={'/properties/' + property.slug}
            >
                <div>
                    <div className='relative'>
                        <Image
                            placeholder="blur"
                            blurDataURL={property.blur}
                            className='large-card-image'
                            src={property.cover}
                            width={imageWidth}
                            height={imageHeight}
                            alt={property.slug}
                        />
                        {includeInactive && (property.listingStatus !== 'active' || property.active == false) ? (
                            // <div className='absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] bg-third text-light p-1 text-xxl rounded-md z-10 font-semibold'>{property.saleType == 'sale' ? 'Sold' : 'Rented'}</div>

                            <div className='absolute top-0 left-0 right-0 bottom-0 bg-maincolor opacity-50 z-11 rounded-md flex justify-center items-center'>
                                <span className='text-light text-6xl z-12'>{property.saleType == 'sale' ? 'SOLD' : 'RENTED'}</span>
                            </div>
                        ) : null
                        }
                        {property.publicTransport ? (
                            <div className='absolute flex flex-row flex-wrap bottom-0 left-0'>
                                {property.publicTransport.map((transport, index) => (
                                    <div key={index} style={{ backgroundColor: transport.colorCode }} className={`rounded-sm px-1 text-light text-sm ml-1 mb-1`}>{transport.type.toUpperCase()} {transport.transportName?.[lang] ? transport.transportName[lang] : transport.stationName}</div>
                                ))}
                            </div>
                        ) : null}
                        {property.promotionTitle && (
                            <div className="label-highlight">{property.promotionTitle}</div>
                        )}
                    </div>
                    <div className='sm:w-[300px] w-full rounded-md' >
                        <div width={imageWidth} className='text-xl font-semibold text-maincolor relative flex flex-col justify-between sm:overflow-hidden sm:h-[85px] h-full' title={property.name}>
                            <h2>
                                {property.name}
                            </h2>
                            {/* <div className='relative w-full flex flex-row-reverse'> */}
                            {/* <div className='absolute z-40 right-0 left-0 top-[-30px] h-[30px] bg-gradient-to-b from-transparent to-light'></div> */}
                            <div className='sm:absolute z-40 right-0 left-0 bottom-0 sm:h-[30px] h-0 bg-gradient-to-b from-transparent to-light'></div>
                            {/* </div> */}
                        </div>
                        {property.salePrice !== undefined && (
                            <div className='text-xl font-semibold text-third'><CurrencySymbol lang={lang} />{property.salePrice}</div>
                        )}
                        {property.rentPrice !== undefined && (
                            <div className='text-xl font-semibold text-third'><CurrencySymbol lang={lang} />{property.rentPrice}{`/${dictionary.month}`}</div>
                        )}
                        {property.metaCategory == 'Land' ? (
                            <div className='flex flex-row'>
                                <div className='flex flex-row items-center'>
                                    <span className='mr-1 text-maincolor'>{property.livingArea} {dictionary.sqm}</span>
                                    <AiOutlineLayout
                                        color={tailwindConfig.theme.extend.colors.secondary}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className='flex flex-row'>
                                {property.metaCategory.toLowerCase() === 'condo' && property.subcategory?.toLowerCase() === 'studio' && (
                                    <div className='flex flex-row items-center mr-2'>
                                        <span className='mr-1 text-maincolor'>{dictionary.studio}</span>
                                        {/* <BiSolidBed
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                        /> */}
                                    </div>
                                )}
                                {(property.metaCategory.toLowerCase() === 'condo' || property.metaCategory.toLowerCase() === 'house') && property.subcategory?.toLowerCase() !== 'studio'  && property.bedrooms!== undefined && property.bedrooms > 0 &&
                                    <div className='flex flex-row items-center mr-2'>
                                        <span className='mr-1 text-maincolor'>{property.bedrooms}</span>
                                        <BiSolidBed
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                        />
                                    </div>
                                }
                                {(property.bathrooms !== undefined && property.bathrooms > 0) &&
                                    <div className='flex flex-row items-center mr-2'>
                                        <span className='mr-1 text-maincolor'>{property.bathrooms}</span>
                                        <BiSolidBath
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                        />
                                    </div>
                                }
                                {(property.livingArea !== undefined && property.livingArea > 0) && (
                                    <div className='flex flex-row items-center'>
                                        <span className='mr-1 text-maincolor'>{property.livingArea} {dictionary.sqm}</span>
                                        <AiOutlineLayout
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                        />
                                    </div>
                                )}
                            </div>
                        )}

                        {(/*property.foreignQuota || */property.isPetFriendly) ? (
                            <div className='flex flex-row'>
                                {/* {property.foreignQuota && property.saleType == 'sale' ? (
                                    <div className={`rounded-md p-1 text-third border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><MdPlaylistAddCheckCircle /><span className='ml-1'>Foreign Quota</span></div>
                                ) : null} */}
                                {property.videoUrl ? (
                                    <div className={`rounded-md p-1 text-light bg-third text-sm mr-1 flex flex-row items-center`}><IoMdVideocam /><span className='ml-1'>{dictionary.video}</span></div>
                                ) : null}
                                {property.isPetFriendly ? (
                                    <div className={`rounded-md p-1 text-secondary border-secondary border-[1px] text-sm mr-1 flex flex-row items-center`}><MdPets /><span className='ml-1'>{dictionary.petFriendly}</span></div>
                                ) : null}
                            </div>
                        ) : null}
                        <div>
                            {district == undefined ? (
                                <p className='text-mainhover'>{property.districts[0]?.subdistrictName?.[lang] ? property.districts[0].subdistrictName[lang] : property.districts[0]?.subdistrict}, {property.location}</p>
                            ) : (
                                <p className='text-mainhover'>{district.subdistrictName?.[lang] ? district.subdistrictName[lang] : district.subdistrict}, {property.location}</p>
                            )}
                        </div>
                    </div>
                </div>
                {/* <div>{property.name}</div> */}
            </LinkComponent >
        </div>
    )
}

export default LargePropertyCard